import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleResize = this.handleResize.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    
    window.addEventListener('resize', this.handleResize)
    this.handleResize() // Initial check
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    if (window.innerWidth >= 1024) {
      window.addEventListener('scroll', this.handleScroll)
      this.handleScroll()
    } else {
      window.removeEventListener('scroll', this.handleScroll)
      this.resetStyles()
    }
  }

  resetStyles() {
    this.element.style.position = ''
    this.element.style.top = ''
    this.element.style.width = ''
    this.element.style.bottom = ''
  }

  handleScroll() {
    const parentContainer = this.element.parentElement
    const parentRect = parentContainer.getBoundingClientRect()
    const elementHeight = this.element.offsetHeight

    // Reset position to static when parent is not in view
    if (parentRect.top > window.innerHeight || parentRect.bottom < 0) {
      this.element.style.position = 'static'
      return
    }

    // Calculate boundaries
    const parentTop = parentRect.top
    const parentBottom = parentRect.bottom
    const offset = 8 // equivalent to top-2 in Tailwind

    // If parent is entering viewport from the top
    if (parentTop <= offset) {
      this.element.style.position = 'fixed'
      this.element.style.top = `${offset}px`
      this.element.style.width = `${parentContainer.offsetWidth}px`

      // Check if element is hitting parent bottom boundary
      const elementBottom = offset + elementHeight
      const distanceToParentBottom = parentBottom - elementBottom
      
      if (distanceToParentBottom < 0) {
        this.element.style.position = 'absolute'
        this.element.style.top = 'auto'
        this.element.style.bottom = '0'
      }
    } else {
      // Reset to static position when above starting point
      this.element.style.position = 'static'
      this.element.style.width = '100%'
    }
  }
}